import { createClient } from "@sanity/client";

// Crear una variable para almacenar la instancia del cliente
let clientInstance = null;

// Función que devuelve la instancia del cliente
export function getSanityClient() {
  // Si ya existe una instancia, la retornamos
  if (clientInstance) {
    return clientInstance;
  }

  // Si no existe, creamos una nueva instancia y la almacenamos
  clientInstance = createClient({
    projectId: "budnts3p",
    dataset: "production",
    useCdn: true, // Esto depende de si quieres caché o no
  });

  return clientInstance;
}
